export default "__VITE_ASSET__CnV337tY__"